import Vue from 'vue';
import { Validator } from 'vee-validate';
export default function () {
  this.jobAdValidation = function () {
    const dictonary = {
      custom: {
        JobAdCode: {
          required: () => "JobAdCode is required"
        },
        CompCode: {
          required: () => "CompCode is required"
        },
        JobCode: {
          required: () => "JobCode is required"
        },
        DateFrom: {
          required: () => "DateFrom is required"
        },
        DateTo: {
          required: () => "DateTo is required"
        },
        Interviewer: {
          required: () => "Interviewer is required"
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090100-Job/S090100-JobValidation.js